<template>
  <div class="wrapper article-level-twenty-two" :class="'theme-' + theme">
    <div class="card">
      <div class="inner">
        <node-link
          :url="node.relative_url"
          :type="node.type"
          :nid="node.nid"
          :title="node.title"
          :destinationTid="destinationTid"
          >
          <div class="card-title">
            {{title}}
          </div>
          <div class="subheading" v-html="subheading" v-if="theme === 'full'"></div>
        </node-link>
        <div class="footer">
          <field-date :simpleDate="true" class="text-left" :nid="nid"></field-date>
          <share-count
            class="share-count"
            v-if="shareData.url"
            :url="shareData.url"
          ></share-count>
        </div>
      </div>
      <node-link
        :url="node.relative_url"
        :type="node.type"
        :nid="node.nid"
        :title="node.title"
        :destinationTid="destinationTid"
        class="image-wrapper"
        >
        <progressive-image class="disable-photoslider"
          :progressiveImage="progressiveImage"
          :alt="node.title"
          :lazyload="true"
          width="112"
          height="60"
          />
      </node-link>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get'
import sectionMixin from 'components/mixins/section'
import FieldDate from 'components/node/fields/Date.vue'

import { updateTitleByNodeType, getSocialHeadLineAsTitle, rewriteImageSrc } from 'mixins/utilities'
import find from "lodash/find";

export default {
  name: 'article-level-twenty-two',
  mixins: [sectionMixin],
  props: {
    theme: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    title() {
      return getSocialHeadLineAsTitle(this.node)
    },
    destinationTid() {
      return get(this.getLastSection(get(this, 'node.sections', [])), 'tid', false)
    },
    image() {
      return find(get(this, 'node.images', []), {type: 'cover'})
    },
    subheading() {
      return get(this, 'node.subheading')
    },
    progressiveImage() {
      return {
        src: rewriteImageSrc(get(this, 'image.style_700x400')),
        loading: rewriteImageSrc(get(this, 'image.style_134w')),
        svg: {
          width: 47,
          height: 26,
        },
      }
    },
    shareData () {
      const obj = {
        url: `${this.requestDomain}${get(this.node, 'relative_url', '')}`,
        shortenUrl: get(this.node, 'shorten_url', ''),
        title: updateTitleByNodeType({
          type: get(this, 'node.type', ''),
          originalTitle: get(this.node, 'title', ''),
        }),
        thumbnail: get(this, 'node.images[0].style_700x400'),
      }
      return obj
    },
  },
  components: {
    FieldDate,
  },
}
</script>

<style lang="scss" scoped>
  .article-level-twenty-two {
    font-family: $barlow;
    &.theme-dark .card-title {
      color: $white;
    }
  }

  .card {
    border: none;
    border-radius: 0;
    background-color: transparent;
    padding-bottom: rem-calc(10);
    border-bottom: 1px solid $tc-gray;
    margin-bottom: rem-calc(10);
    font-size: rem-calc(12);
    color: $darker-gray-2;

    @include respond-to("desktop") {
      display: flex;
      flex-direction: row;
      margin-bottom: rem-calc(15);
      padding-bottom: rem-calc(15);

      .inner {
        order: 1;
        padding-left: rem-calc(9);
        flex-direction: column;
        justify-content: space-between;
        display: flex;
      }
    }

    a {
      min-height: 1px; // for IE fix
      overflow: hidden;
    }

    img, .progressive-image {
      @include respond-to("desktop") {
        width: rem-calc(210);
        height: auto;
      }

      width: 100%;
      height: auto;
      float: left;
    }
  }
  a:active,
  a:focus {
    img {
      -webkit-filter: $image-hover-opacity;
      filter: $image-hover-opacity;
      color: $white;
    }
  }

  .card-title {
    @include respond-to("desktop") {
      font-size: rem-calc(17);
      -webkit-line-clamp: 4;
      margin-bottom: 0;
    }
    margin-bottom: rem-calc(5);
    font-size: rem-calc(15);
    color: $darker-gray-2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    font-weight: 600;
    line-height: normal;
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .article-level-twenty-two  .published-date, .article-level-twenty-two .share-count {
    color: $darker-gray-2;
    font-size: rem-calc(12);
    line-height: 100%;
  }

  .share-count {
    .share-text {
      padding-left: rem-calc(3);
      text-transform: capitalize;
    }
  }

  .theme-full {
    @include respond-to("mobile") {
      display: none;
    }

    .card {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .card-title {
      font-size: rem-calc(30);
      -webkit-line-clamp: 3;
      margin-top: rem-calc(-8);
    }
    .subheading {
      font-size: rem-calc(18);
      line-height: rem-calc(26);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      font-family: $roboto;
      color: $darker-gray-2;
      margin-top: rem-calc(11);
    }
    .inner {
      padding-left: rem-calc(20);

      a:hover {
        text-decoration: none;
        .card-title {
          text-decoration: underline;
        }
        .subheading {
          text-decoration: none;
        }
      }
    }

    .footer {
      background: $dirty-yellow;
      padding: rem-calc(10);
    }

    .published-date, .share-count {
      font-size: rem-calc(14);
    }
    .image-wrapper {
      margin-right: rem-calc(20);

      img, .progressive-image {
        width: 100%;
      }
    }

    .image-wrapper, .inner {
      flex: 1 50%;
    }

    .share-count {
      font-weight: bold;
    }
  }

  .image-wrapper {
    min-width: 210px;
    overflow: hidden;
    @include respond-to("mobile") {
      margin-top: rem-calc(10);
      display: none;
    }
  }

  .card {
    /deep/ img {
      transition: transform 150ms ease;
    }
  }

  .card:hover /deep/ img {
    transform: scale(1.02);
    transform-origin: center;
  }

  .last-two {
    @include respond-to("desktop") {
      .card {
        border-bottom: 0;
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
  @include respond-to("mobile") {
    .wrapper:nth-child(4n+1) .image-wrapper {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// components/article-levels/Lv22.vue